import React from 'react';
import styled from 'styled-components';

import { getColor } from '../styles/themeGetters';
import { getConfidenceLevelColor } from '../utils/getConfidenceLevelColor';

type ConfidenceLevelDotSize = 'small' | 'regular';

type Props = {
  value: number;
  size?: ConfidenceLevelDotSize;
};

const DIAMETERS: Record<ConfidenceLevelDotSize, string> = {
  small: '8px',
  regular: '10px',
};

const Dot = styled.span<{ $diameter: string; $color: string }>`
  display: inline-block;
  flex-shrink: 0;
  width: ${props => props.$diameter};
  height: ${props => props.$diameter};
  border-radius: 100%;
  background-color: ${props => props.$color};
`;

const ConfidenceLevelDot = ({ value, size = 'regular' }: Props) => (
  <Dot
    $diameter={DIAMETERS[size]}
    $color={getColor(getConfidenceLevelColor(value) ?? 'grey')}
    aria-hidden
  />
);

export { ConfidenceLevelDot };
